import { useQuery } from "@apollo/client";
import { Summary } from "./summary";
import { ApplicantCasesSendReportArchiveSummaryContainerApplicantUserDocument, ApplicantCasesSendReportArchiveSummaryContainerArchivedSendReportCaseSummaryDocument, ApplicantCasesSendReportArchiveSummaryContainerArchivedSendReportCaseSummaryFieldsFragment } from "../../../../../../generated";
import { ComponentQueryLoader } from "../../../../../shared/component-query-loader";


interface SummaryContainerProps {
 caseId: string;
 applicantId: string;
}

export const SummaryContainer: React.FC<SummaryContainerProps> = (props) => {
  const { data, loading, error } = useQuery(ApplicantCasesSendReportArchiveSummaryContainerArchivedSendReportCaseSummaryDocument, {
    variables: {
      id: props.caseId,
    },
    context: {
      headers: {
        "cache-enabled": "true",
      },
    },
  });

  const {
    data: applicantData,
    loading: applicantLoading,
    error: applicantError,
  } = useQuery(ApplicantCasesSendReportArchiveSummaryContainerApplicantUserDocument, {
    variables: {
      id: props.applicantId,
    },
  });

  return (
    <ComponentQueryLoader
      loading={loading && applicantLoading}
      error={error || applicantError}
      hasData={data !== undefined && applicantData !== undefined}
      hasDataComponent={
        <Summary
          data={data?.archivedSendReportCaseSummary as ApplicantCasesSendReportArchiveSummaryContainerArchivedSendReportCaseSummaryFieldsFragment}
        />
      }
    />
  );
};

